import { User } from "@/types/user";
import { eventHandlers } from "@/utils/analytics/customEventTracking";

const analyticsClickHandler =
  ({
    eventName,
    eventArgs,
    clickHandler,
  }: {
    eventName: string;
    eventArgs: any;
    clickHandler?: () => void;
  }) =>
  () => {
    eventHandlers[eventName](eventArgs);
    if (clickHandler) {
      clickHandler();
    }
  };

export { analyticsClickHandler };

interface CustomWindow extends Window {
  _sva: {
    traits?: any;
    invokeEvent?: (eventName: string, properties?: any) => void;
  };
}
declare let window: CustomWindow;

export const survicateEventNames = {
  DOWNLOAD_TEST_RESULT: "download_test_result",
};

export const loadSurvicate = (currentUser: User, extraTraits = {}) => {
  const survicateKey = process.env.REACT_APP_SURVICATE_KEY;
  if (survicateKey) {
    // survicate code for identifying the user attributes. Must be called before main survicate script is loaded
    // https://help.survicate.com/en/articles/3937812-target-your-survey-based-on-respondent-attributes
    (function (opts) {
      opts.traits = {
        email: currentUser.identity.email,
        ...extraTraits,
      };
    })((window._sva = window._sva || {}));

    const survicateScript = document.createElement("script");
    survicateScript.src = `https://survey.survicate.com/workspaces/${survicateKey}/web_surveys.js`;
    survicateScript.async = true;

    survicateScript.onerror = () => {
      console.error("Failed to load Survicate script");
    };

    document.body.appendChild(survicateScript);

    return () => {
      // Remove the script when the component unmounts
      if (document.body.contains(survicateScript)) {
        document.body.removeChild(survicateScript);
      }
    };
  } else {
    console.log("Survicate not initialized since no key was provided.");
  }
};

export const triggerSurvicateSurvey = (
  eventName: string,
  properties?: Record<string, any>
) => {
  const attemptTrigger = () => {
    if (window._sva && window._sva.invokeEvent) {
      try {
        window._sva.invokeEvent(eventName, properties);
      } catch (e) {
        console.error("Failed to invoke Survicate event", e);
      }
      return true;
    }
    return false;
  };

  if (attemptTrigger()) return;

  const retryDelays = [500, 1000, 2000];
  let retryCount = 0;

  const retry = () => {
    if (retryCount >= retryDelays.length) {
      return;
    }

    setTimeout(() => {
      if (attemptTrigger()) return;
      retryCount++;
      retry();
    }, retryDelays[retryCount]);
  };

  retry();
};
